module.exports={
	"Form": "LineItemEditManifest",
	"Scope": "LineItem-Edit",
	"Descriptors":
	{
		"LineItemDetails.Name":
		{
			"Name": "Name",
			"Hash": "LineItem-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "LineItem-Edit-Identity",
				"Group": "LineItem-Edit-Identity"
			}
		},
		"LineItemDetails.ItemCode":
		{
			"Name": "Item Code",
			"Hash": "LineItem-Edit-ItemCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "LineItem-Edit-Identity",
				"Group": "LineItem-Edit-Identity"
			}
		},
		"LineItemDetails.Description":
		{
			"Name": "Description",
			"Hash": "LineItem-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "LineItem-Edit-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.Units":
		{
			"Name": "Units",
			"Hash": "LineItem-Edit-Units",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.SpecificationYear":
		{
			"Name": "Specification Year",
			"Hash": "LineItem-Edit-SpecificationYear",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.ItemNumber":
		{
			"Name": "Item Number",
			"Hash": "LineItem-Edit-ItemNumber",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.CostPerUnit":
		{
			"Name": "Cost Per Unit",
			"Hash": "LineItem-Edit-CostPerUnit",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.ExpectedQuantity":
		{
			"Name": "Expected Quantity",
			"Hash": "LineItem-Edit-ExpectedQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.ContractorReportedQuantity":
		{
			"Name": "Contractor Reported Quantity",
			"Hash": "LineItem-Edit-ContractorReportedQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.ActualQuantity":
		{
			"Name": "Actual Quantity",
			"Hash": "LineItem-Edit-ActualQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.ContractQuantity":
		{
			"Name": "Contract Quantity",
			"Hash": "LineItem-Edit-ContractQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.InstalledQuantity":
		{
			"Name": "Installed Quantity",
			"Hash": "LineItem-Edit-InstalledQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.ChangeOrderQuantity":
		{
			"Name": "Change Order Quantity",
			"Hash": "LineItem-Edit-ChangeOrderQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "7",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.ChangeOrderQuantityPending":
		{
			"Name": "Change Order Quantity Pending",
			"Hash": "LineItem-Edit-ChangeOrderQuantityPending",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "7",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.Tax":
		{
			"Name": "Tax",
			"Hash": "LineItem-Edit-Tax",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "7",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.ChangeOrderNumber":
		{
			"Name": "Change Order Number",
			"Hash": "LineItem-Edit-ChangeOrderNumber",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "8",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.FundingCategory":
		{
			"Name": "Funding Category",
			"Hash": "LineItem-Edit-FundingCategory",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "8",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.IDFundingCategory":
		{
			"Name": "Funding Category",
			"Hash": "LineItem-Edit-IDFundingCategory",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "8",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details",
				"Entity": "FundingCategory",
				"SearchFields":
				[
					"Name",
					"Code",
					"Description"
				]
			}
		},
		"LineItemDetails.Status":
		{
			"Name": "Status",
			"Hash": "LineItem-Edit-Status",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "9",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.ProposalIdentifier":
		{
			"Name": "Proposal Identifier",
			"Hash": "LineItem-Edit-ProposalIdentifier",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "9",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.PercentComplete":
		{
			"Name": "Percent Complete",
			"Hash": "LineItem-Edit-PercentComplete",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "9",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.CategoryNumber":
		{
			"Name": "Category Number",
			"Hash": "LineItem-Edit-CategoryNumber",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "10",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.Retainage":
		{
			"Name": "Retainage",
			"Hash": "LineItem-Edit-Retainage",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "10",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.ImprovementType":
		{
			"Name": "Improvement Type",
			"Hash": "LineItem-Edit-ImprovementType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "10",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.DeliveryDate":
		{
			"Name": "Delivery Date",
			"Hash": "LineItem-Edit-DeliveryDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "11",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.ParentIDLineItem":
		{
			"Name": "Parent Line Item",
			"Hash": "LineItem-Edit-ParentIDLineItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "11",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details",
				"Entity": "LineItem",
				"SearchFields":
				[
					"Name",
					"ItemNumber"
				]
			}
		},
		"LineItemDetails.IDPayItem":
		{
			"Name": "Pay Item",
			"Hash": "LineItem-Edit-IDPayItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "11",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details",
				"Entity": "PayItem",
				"SearchFields":
				[
					"Description",
					"ItemCode",
					"Name"
				]
			}
		},
		"LineItemDetails.IDBidItem":
		{
			"Name": "Bid Item",
			"Hash": "LineItem-Edit-IDBidItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "12",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details",
				"Entity": "BidItem",
				"SearchFields":
				[
					"Name",
					"Description"
				]
			}
		},
		"LineItemDetails.IDContract":
		{
			"Name": "Contract",
			"Hash": "LineItem-Edit-IDContract",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "12",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details",
				"Entity": "Contract",
				"SearchFields":
				[
					"Name",
					"Description",
					"PrimaryProjectNumber",
					"CountyProjectNumber"
				]
			}
		},
		"LineItemDetails.IDProject":
		{
			"Name": "Project",
			"Hash": "LineItem-Edit-IDProject",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "12",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details",
				"Entity": "Project",
				"SearchFields":
				[
					"Name",
					"Description",
					"PurchaseOrderNumber",
					"ImprovementTypeCode"
				]
			}
		},
		"LineItemDetails.FHWAEligible":
		{
			"Name": "FHWAEligible",
			"Hash": "LineItem-Edit-FHWAEligible",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "13",
				"Width": 3,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.IDLineItem":
		{
			"Name": "IDLine Item",
			"Hash": "LineItem-Edit-IDLineItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "14",
				"Width": 4,
				"Section": "LineItem-Edit-DataAudit",
				"Group": "LineItem-Edit-DataAudit"
			}
		},
		"LineItemDetails.GUIDLineItem":
		{
			"Name": "GUIDLine Item",
			"Hash": "LineItem-Edit-GUIDLineItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "14",
				"Width": 4,
				"Section": "LineItem-Edit-DataAudit",
				"Group": "LineItem-Edit-DataAudit"
			}
		},
		"LineItemDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "LineItem-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "14",
				"Width": 4,
				"Section": "LineItem-Edit-DataAudit",
				"Group": "LineItem-Edit-DataAudit"
			}
		},
		"LineItemDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "LineItem-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "15",
				"Width": 4,
				"Section": "LineItem-Edit-DataAudit",
				"Group": "LineItem-Edit-DataAudit"
			}
		},
		"LineItemDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "LineItem-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "15",
				"Width": 4,
				"Section": "LineItem-Edit-DataAudit",
				"Group": "LineItem-Edit-DataAudit"
			}
		},
		"LineItemDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "LineItem-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "15",
				"Width": 4,
				"Section": "LineItem-Edit-DataAudit",
				"Group": "LineItem-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "LineItem-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "LineItem-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "LineItem-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "LineItem-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "LineItem-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "LineItem-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
